import { ref } from 'vue';

export class Mobile {
	public static readonly instance = new Mobile();

	public readonly isMobile = ref(false);

	private constructor() {
		if (window.Shared) {
			this.update();
			window.addEventListener(
				'resize',
				window.Shared.debounce(() => this.update(), 100),
			);
		}
	}

	private update(): void {
		this.isMobile.value = window.Shared.breakpoints(['Small', 'Medium']);
	}
}
